<template>
  <div id="FamilyBadgeManagement">
    <v-form ref="profileLayoutSettings">
      <v-container>
        <v-layout class="button-container"> 
          <v-flex xs12 sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="cancelEdit">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="submitSettings">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-tabs
          v-model="tabsModel"
          slider-color="#019d8c"
          class="pf-tabs-teal layout-main-tab pf-tab"
          id="top-tabs"
        >
          <v-tab href="#tab-1">General</v-tab>
          <v-tab href="#tab-2" v-if="Agency.is_super_admin || session.getSession().adminUser">OpenAI Settings</v-tab>
          <v-tab href="#tab-3">Chapters</v-tab>
          <v-tab href="#tab-4">Chapter Settings</v-tab>
          <v-tab href="#tab-5">Custom Chapters</v-tab>
          <v-tab href="#tab-6">Templates</v-tab>

          <v-tab-item value="tab-1">
            <v-card flat>
              <v-card-text>
                <v-layout class="flex-column my-2">
                  <h5 class="mb-2 ">
                    <b>General Settings</b>
                  </h5>
                  <table class="pf-simple-table white-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-4">Maximum number of chapters</td>
                        <td>
                          <v-text-field class="ma-0 pa-0" v-model="profileSettings.max_chapters" :rules="rules.intRequired" @change="isFormDataChanged = true"></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-4">Is center spread required</td>
                        <td>
                          <v-radio-group v-model="profileSettings.center_spread_required" row class="ma-0 pa-0" @change="isFormDataChanged = true">
                            <v-radio
                              v-for="(type, j) in yesOrNo"
                              :key="j"
                              color="teal"
                              :label="`${type.text}`"
                              :value="type.value"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-4">Is back cover required</td>
                        <td>
                          <v-radio-group v-model="profileSettings.back_cover_required" row class="ma-0 pa-0" @change="isFormDataChanged = true">
                            <v-radio
                              v-for="(type, j) in yesOrNo"
                              :key="j"
                              color="teal"
                              :label="`${type.text}`"
                              :value="type.value"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-4">Is organization approval required</td>
                        <td>
                          <v-radio-group v-model="profileSettings.agency_approval_required" row class="ma-0 pa-0" @change="isFormDataChanged = true">
                            <v-radio
                              v-for="(type, j) in yesOrNo"
                              :key="j"
                              color="teal"
                              :label="`${type.text}`"
                              :value="type.value"
                            ></v-radio>
                          </v-radio-group>
                          <v-combobox
                            v-if="profileSettings.agency_approval_required"
                            v-model="profileSettings.agency_approval_emails"
                            :items="profileSettings.agency_approval_emails"
                            :rules="rules.emailRules"
                            label="Email addresses - hit enter to add" multiple deletable-chips small-chips
                            persistent-hint 
                            hint="Enter valid email addresses"
                            @change="isFormDataChanged = true"></v-combobox>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>

        <v-tab-item value="tab-2" v-if="Agency.is_super_admin || session.getSession().adminUser">
          <v-card flat>
            <v-card-text>
              <v-layout wrap class="my-2">
                <h5 class="mb-2">
                  <b>OpenAI Settings</b>
                </h5>
                <table class="pf-simple-table white-table">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Value</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(setting, s) in profileSettings.ai" :key="s">
                      <td class="text-center">{{ s + 1 }}</td>
                      <td>
                        <v-text-field v-model="setting.name" @change="isFormDataChanged = true" class="pa-0 ma-0 required"></v-text-field>
                      </td>
                      <td>
                        <v-select v-model="setting.type" @change="isFormDataChanged = true" :items="[{ text: 'String', value: 'string' }, { text: 'Number', value: 'number' }, { text: 'Boolean', value: 'boolean'}]" class="pa-0 ma-0 required">
                        </v-select>
                      </td>
                      <td>
                        <v-text-field v-model="setting.value" @change="isFormDataChanged = true" class="pa-0 ma-0 required"></v-text-field>  
                      </td>
                      <td>
                        <v-btn @click="submitSettings" title="Save setting" class="pf-btn pf-btn-save" v-if="isAISettingAdd && s === profileSettings.ai.length - 1">
                          Save
                        </v-btn>
                        <v-btn icon @click="removeAISetting(s)" title="Remove setting">
                          <v-icon color="red" size="20">delete_outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5">
                        <v-btn :disabled="profileSettings.ai.length !== profileSettings.ai.filter(x => x.name && x.type && typeof x.value !== 'undefined').length" title="Add setting" @click="addAISetting" class="pf-btn pf-btn-save">
                          Add new
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item value="tab-3">
          <v-card flat>
            <v-card-text>
              <v-layout class="my-2 flex-column">
                <v-layout wrap class="flex-column">
                  <v-flex sm3>
                    <h5 class="mb-2">
                      <b>Default Chapters</b>
                    </h5>
                  </v-flex>
                  <v-flex sm3>
                    <v-select :full-width="false" v-model="accountType" :items="['All', 'Single', 'Couple']" label="Filter by Account Type">
                    </v-select>
                  </v-flex>
                </v-layout>
                <table class="pf-simple-table white-table">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th>Chapter Name</th>
                      <th>Account Type</th>
                      <th class="text-center">Default</th>
                      <th class="text-center">Required</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(chapter, c) in filteredDefaultChapters" :key="c" :class="{ 'pf-border-teal-2 border-radius-5': addedNewChapter && c === profileSettings.default_chapters.length - 1 }">
                      <td class="text-center">{{ c + 1 }}</td>
                      <td class="px-4">
                        <v-text-field v-if="chapter.name !== 'new_chapters'" v-model="chapter.name" @change="isFormDataChanged = true" class="pa-0 ma-0 required"></v-text-field>
                        <span v-else>Family Custom Chapters</span>
                      </td>
                      <td class="px-4">
                        <v-select 
                          v-if="chapter.name !== 'new_chapters'"
                          v-model="chapter.accountType" 
                          :items="['Single', 'Couple', 'Both']" 
                          @change="isFormDataChanged = true"
                        >
                        </v-select>
                        <span v-else>Both</span>
                      </td>
                      <td class="text-center">
                        <v-checkbox
                          v-model="chapter.default"
                          @change="chapter.required = false; isFormDataChanged = true"
                          class="flex-center"
                          color="teal"
                          v-if="chapter.name !== 'new_chapters'"
                          :disabled="profileSettings.default_chapters.filter(x => x.default).length === profileSettings.max_chapters"
                        >
                        </v-checkbox>
                        <span v-else>--</span>
                      </td>
                      <td class="text-center">
                        <v-checkbox
                          v-model="chapter.required"
                          @change="isFormDataChanged = true"
                          class="flex-center"
                          color="teal"
                          v-if="chapter.name !== 'new_chapters'"
                          :disabled="!chapter.default"
                        >
                        </v-checkbox>
                        <span v-else>--</span>
                      </td>
                      <td>
                        <template v-if="chapter.name !== 'new_chapters'">
                          <v-btn icon @click.stop="deleteChapter(chapter, c)" title="Delete Chapter">
                            <v-icon color="red" size="20">delete_outline</v-icon>
                          </v-btn>
                          <v-btn icon title="Change Order" v-if="['All'].indexOf(accountType) === -1">
                            <v-icon class="grey--text cursor-pointer chapterSortHandle" size="20">open_with</v-icon>
                          </v-btn>
                        </template>
                        <span v-else>--</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6">
                        <v-btn :disabled="profileSettings.default_chapters.length !== profileSettings.default_chapters.filter(x => x.name).length" title="Add Chapter" @click="addNewChapter" class="pf-btn pf-btn-save">
                          Add new
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item value="tab-4">
          <v-card flat>
            <v-card-text>
              <v-layout class="my-2">
                <v-flex xs12>
                  <h5>
                    <b>Chapter Settings</b>
                  </h5>
                  <v-layout wrap>
                    <v-flex sm4>
                      <v-select  
                        v-model="selectedChapter"
                        :items="profileSettings.default_chapters.filter(x => x.name !== 'covers_spread')" 
                        label="Select the Chapter"
                        class="mb-3"
                        item-text="name"
                        return-object
                        @change="changeCurrentChapter"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout class="pf-border-lighter-1 pa-2" v-if="currentChapter">
                    <v-card-text class="pa-0">
                      <v-layout wrap>
                        <v-flex class="flex-column" xs12>
                          <p>
                            <!-- <span v-if="'new_chapters' === currentChapter.name" class="font-italic">Default content for the <b>new chapters</b></span> -->
                            <span class="font-italic mt-2">- Default content for "<b>{{ currentChapter.text }}</b>"</span>
                          </p>
                          <editor
                            v-if="'new_chapters' === currentChapter.name"
                            :options="editorOption"
                            @onKeyUp="isFormDataChanged = true" @onPaste="isFormDataChanged = true"
                            :content="content"
                            :init="init"
                            :api-key="config.tinymceEditorKey"
                            v-model="profileSettings.default_content"
                          />
                          <editor
                            v-else
                            :options="editorOption"
                            @onKeyUp="isFormDataChanged = true" @onPaste="isFormDataChanged = true"
                            :content="content"
                            :init="init"
                            :api-key="config.tinymceEditorKey"
                            v-model="currentChapter.content"
                          />
                        </v-flex>
                        <v-flex class="flex-column my-3" xs12>
                          <p>
                            <span class="font-italic mt-2">- Tips for "<b>{{ currentChapter.text }}</b>"</span>
                            <!-- <span v-else-if="'covers_spread' === currentChapter.name" class="font-italic">Tips for writing {{ currentChapter.text }}</span> -->
                            <!-- <span v-else class="font-italic">2. Tips for "<b>{{ currentChapter.text }}"</b></span> -->
                          </p>
                          <editor
                            v-if="['new_chapters', 'covers_spread'].indexOf(currentChapter.name) > -1"
                            :options="editorOption"
                            @onKeyUp="isFormDataChanged = true" @onPaste="isFormDataChanged = true"
                            :content="content"
                            :init="init"
                            :api-key="config.tinymceEditorKey"
                            v-model="profileSettings.tips_text[currentChapter.name]"
                          />
                          <editor
                            v-else
                            :options="editorOption"
                            @onKeyUp="isFormDataChanged = true" @onPaste="isFormDataChanged = true"
                            :content="content"
                            :init="init"
                            :api-key="config.tinymceEditorKey"
                            v-model="currentChapter.tips"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout class="my-3 flex-column">
                        <!-- <h5 class="mb-2 font-weight-bold">Add questions for writing assistance</h5> -->
                        <span class="font-weight-bold mb-2 font-italic">- Add questions for writing assistance</span>
                        <v-layout wrap>
                          <v-flex sm12 v-for="(question, q) in currentChapter.AIQuestions" :key="q">
                            <v-textarea outline class="pf-font-14 px-4" @change="isFormDataChanged = true" v-model.trim="question.question" :rules="[v => !!v || 'Please type your question']" :label="`Question ${q + 1}`" append-icon="cancel" @click:append="removeQuestion(q)"></v-textarea>
                          </v-flex>
                        </v-layout>
                        <v-layout class="flex-column">
                          <v-flex v-if="!currentChapter.AIQuestions || !currentChapter.AIQuestions.length
                          ">
                            <p class="px-2">No writing assistance questions found</p>
                          </v-flex>
                          <v-flex>
                            <v-btn title="Add question" :disabled="Boolean(currentChapter.AIQuestions && currentChapter.AIQuestions.length && currentChapter.AIQuestions.filter(x => x && (!x.question || !x.question.trim().length)).length)" @click.stop="addNewQuestion()" class="pf-btn pf-btn-save">
                              <v-icon class="pf-text-white" size="18">add</v-icon>
                              Add question
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-layout>

                      <hr class="pf-hr"/>

                      <!-- AI settings for each chapter -->
                      <template v-if="Agency.is_super_admin || session.getSession().adminUser">
                        <v-layout class="my-3 flex-column" v-if="currentChapter.name !== 'covers_spread'">
                          <!-- <h5 class="my-2 font-weight-bold">AI settings for the section</h5> -->
                          <span class="my-2 font-weight-bold mb-2 font-italic">- OpenAI Settings</span>
                          <v-layout wrap>
                            <v-flex sm6 v-for="(config, s) in currentChapter.AISettings" :key="s">
                              <v-select 
                                v-model="config.value" 
                                :items="AIToneOptions[config.name]" 
                                :label="config.name"
                                @change="isFormDataChanged = true"
                                class="pr-4 pl-4">
                              </v-select>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </template>

                      <!-- Other chapter settings -->
                      <v-layout class="my-3 flex-column" v-if="currentChapter.name !== 'covers_spread'">
                        <span class="my-2 font-weight-bold mb-2 font-italic">- Other Chapter Settings</span>
                        <table class="pf-simple-table white-table">
                          <thead>
                            <tr>
                              <th class="text-center">#</th>
                              <th>Setting</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">1</td>
                              <td class="px-4">
                                <span>Maximum number of words for chapter content</span>
                              </td>
                              <td>
                                <v-text-field v-model="currentChapter.content_word_count" :rules="rules.intRequired" @change="isFormDataChanged = true"></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-center">2</td>
                              <td class="px-4">
                                <span>Maximum number of photos in a chapter</span>
                              </td>
                              <td>
                                <v-text-field v-model="currentChapter.max_chapter_photos" :rules="rules.intRequired" @change="isFormDataChanged = true"></v-text-field>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </v-layout>

                    </v-card-text>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item value="tab-5">
          <v-card flat>
            <v-card-text>
              <v-layout class="my-2">
                <v-flex xs12>
                  <h5 class="mb-2"><b>Custom Chapter Types</b></h5>
                  <table class="pf-simple-table white-table">
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th>Type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(type, c) in this.profileSettings.custom_chapter_types" :key="c" :class="{ 'pf-border-teal-2 border-radius-5': addedNewCustomType && c === profileSettings.custom_chapter_types.length - 1 }">
                        <td class="text-center">{{ c + 1 }}</td>
                        <td class="px-4">
                          <v-text-field v-model="type.name" @change="isFormDataChanged = true" class="pa-0 ma-0 required"></v-text-field>
                        </td>
                        <td>
                          <template>
                            <v-btn icon @click="deleteCustomType(type, c)" title="Delete Type">
                              <v-icon color="red" size="20">delete_outline</v-icon>
                            </v-btn>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <v-btn title="Add New Type" @click="addNewCustomType" class="pf-btn pf-btn-save">
                            Add new
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h5 class="my-3"><b>Writing Assistance</b></h5>
                  <v-layout wrap>
                    <v-flex sm4>
                      <v-select  
                        v-model="currentType"
                        :items="(profileSettings.custom_chapter_types || []).filter(x => x.name !== 'covers_spread')" 
                        label="Select the Type"
                        class="mb-3"
                        item-text="name"
                        return-object
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout class="pf-border-lighter-1 pa-2" v-if="currentType">
                    <v-card-text class="pa-0">
                      <v-layout class="my-3 flex-column">
                        <span class="font-weight-bold mb-2 font-italic">- Add questions for writing assistance</span>
                        <v-layout wrap>
                          <v-flex sm12 v-for="(question, q) in currentType.AIQuestions" :key="q">
                            <v-textarea outline class="pf-font-14 px-4" @change="isFormDataChanged = true" v-model.trim="question.question" :rules="[v => !!v || 'Please type your question']" :label="`Question ${q + 1}`" append-icon="cancel" @click:append="removeTypeQuestion(q)"></v-textarea>
                          </v-flex>
                        </v-layout>
                        <v-layout class="flex-column">
                          <v-flex v-if="!currentType.AIQuestions || !currentType.AIQuestions.length
                          ">
                            <p class="px-2">No writing assistance questions found</p>
                          </v-flex>
                          <v-flex>
                            <v-btn title="Add question" :disabled="Boolean(currentType.AIQuestions && currentType.AIQuestions.length && currentType.AIQuestions.filter(x => x && (!x.question || !x.question.trim().length)).length)" @click.stop="addNewTypeQuestion()" class="pf-btn pf-btn-save">
                              <v-icon class="pf-text-white" size="18">add</v-icon>
                              Add question
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-layout>

                      <hr class="pf-hr"/>

                      <!-- AI settings for each chapter -->
                      <template v-if="Agency.is_super_admin || session.getSession().adminUser">
                        <v-layout class="my-3 flex-column">
                          <span class="my-2 font-weight-bold mb-2 font-italic">- OpenAI Settings</span>
                          <v-layout wrap>
                            <v-flex sm6 v-for="(config, s) in currentType.AISettings" :key="s">
                              <v-select 
                                v-model="config.value" 
                                :items="AIToneOptions[config.name]" 
                                :label="config.name"
                                @change="isFormDataChanged = true"
                                class="pr-4 pl-4">
                              </v-select>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </template>

                      <!-- Other chapter settings -->
                      <v-layout class="my-3 flex-column" v-if="currentType.name !== 'covers_spread'">
                        <span class="my-2 font-weight-bold mb-2 font-italic">- Other Chapter Settings</span>
                        <table class="pf-simple-table white-table">
                          <thead>
                            <tr>
                              <th class="text-center">#</th>
                              <th>Setting</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">1</td>
                              <td class="px-4">
                                <span>Maximum number of words for chapter content</span>
                              </td>
                              <td>
                                <v-text-field v-model="currentType.content_word_count" :rules="rules.intRequired" @change="isFormDataChanged = true"></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-center">2</td>
                              <td class="px-4">
                                <span>Maximum number of photos in the chapter</span>
                              </td>
                              <td>
                                <v-text-field v-model="currentType.max_chapter_photos" :rules="rules.intRequired" @change="isFormDataChanged = true"></v-text-field>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </v-layout>

                    </v-card-text>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item value="tab-6">
          <v-card flat>
            <v-card-text>
              <v-layout wrap class="my-2">
                <v-flex xs12 class="flex-space-between">
                  <h5 class="mb-2 ">
                    <b>Design Templates</b>
                  </h5>
                  <v-btn title="Add new template" @click.stop="addNewDesign" class="pf-btn pf-btn-save">
                    <v-icon class="pf-text-white" size="18">add</v-icon>
                    Add new
                  </v-btn>
                </v-flex>
                <v-flex v-if="!profileSettings.design_templates || !profileSettings.design_templates.length" class="grey--text pf-font-16 flex-center">
                  No templates found
                </v-flex>
                <v-flex md3 class="flex-center pa-3" v-for="(template, d) in profileSettings.design_templates" :key="d">
                  <div class="elevation-2 flex-column">
                    <a :href="template.file" target="_blank">
                      <v-hover v-slot="{ hover: designHover }">
                        <div class="pf-pos-relative">
                          <img class="pf-width-100p" :src="getFlipbookFirstPage(template.file)" title="Click to view" />
                          <v-flex class="design-overlay flex-center" v-if="designHover">
                            <v-icon class="pf-text-white" size="22">search</v-icon>
                          </v-flex>
                        </div>
                      </v-hover>
                    </a>
                    <v-layout class="px-2 flex-space-between">
                      <v-flex class="mb-2">
                        <span class="grey--text">{{ template.name }}</span>
                      </v-flex>
                      <v-btn title="Delete" icon flat @click.stop="deleteTemplate(d)">
                        <v-icon class="pf-text-pink" size="18">delete</v-icon>
                      </v-btn>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

      </v-tabs>
        


      <v-layout class="button-container"> 
        <v-flex xs12 sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="cancelEdit">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="submitSettings">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>


      </v-container>
    </v-form>

    <app-modal :active="isAddDesign" v-if="isAddDesign" width="60%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="isAddDesign = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add new design</v-toolbar-title>
          </v-toolbar>
          <v-form ref="newDesignForm">
            <v-card-text class="pa-3">
              <v-layout class="pt-1">
                <v-flex>
                  <v-text-field v-model.trim="newDesign.name" :rules="rules.name" label="Design Name"
                  class="required"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="pt-1">
                <v-flex>
                  <v-text-field v-model.trim="newDesign.file" :rules="rules.flipbookLink" label="Flipbook Link"
                  class="required"></v-text-field>
                </v-flex>
              </v-layout>
              <span class="font-italic grey--text">Ex: https://cdn.parentfinder.com/parent/a1b2c3d4e5f6g7h8i9j0k/Flipbook/a1b2c3d4e5f6g7h8i9j0k/12_3456.html</span>
            </v-card-text>
          </v-form>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="submitNewDesign"
            >
              Add
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="closeDesignAdd"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>
<script>

/* global session store config */
// import Vue from 'vue';
import swal from 'sweetalert2';
import { update, getCollection, isEmailValid } from '../../helpers/helpers';
import Editor from '@tinymce/tinymce-vue';
import AppModal from '../../components/AppModal.vue';
import draggable from 'vuedraggable';

// The non-wordpress badge setup page for the agency
export default {
  name: 'ProfileLayoutSetup',
  components: {
    Editor,
    'app-modal': AppModal,
    draggable
  },
  data: vm => ({
    session: session,
    tabsModel: 'tab-1',
    isFormDataChanged: false,
    profileSettingsBackup: {},
    defaultChapters: [
      {
        name: 'new_chapters',
        text: 'Family Custom Chapters',
        default: false,
        required: false,
        AIQuestions: [],
        content_word_count: 250,
        max_chapter_photos: 10,
        accountType: 'Both'
      },
      // { name: 'covers_spread', text: 'Covers & Spread', hide: true },
      {
        name: `Welcome`,
        text: `Welcome`,
        tips: '',
        content: '',
        default: true,
        content_word_count: 250,
        max_chapter_photos: 10,
        required: true,
        accountType: 'Both',
        AIQuestions: []
      },
      {
        name: `About Us`,
        text: `About Us`,
        tips: '',
        content: '',
        default: true,
        required: true,
        accountType: 'Couple',
        content_word_count: 250,
        max_chapter_photos: 10,
        AIQuestions: []
      },
      {
        name: `About Me`,
        text: `About Me`,
        tips: '',
        content: '',
        default: true,
        required: true,
        accountType: 'Single',
        content_word_count: 250,
        max_chapter_photos: 10,
        AIQuestions: []
      },
      {
        name: `About Parent 1`,
        text: `About Parent 1`,
        tips: '',
        content: '',
        default: true,
        required: true,
        accountType: 'Couple',
        content_word_count: 250,
        max_chapter_photos: 10,
        AIQuestions: []
      },
      {
        name: `About Parent 2`,
        text: `About Parent 2`,
        tips: '',
        content: '',
        default: true,
        required: true,
        accountType: 'Couple',
        content_word_count: 250,
        max_chapter_photos: 10,
        AIQuestions: []
      },
      {
        name: `Our Home`,
        text: `Our Home`,
        tips: '',
        content: '',
        default: true,
        required: false,
        accountType: 'Couple',
        content_word_count: 250,
        max_chapter_photos: 10,
        AIQuestions: []
      },
      {
        name: `My Home`,
        text: `My Home`,
        tips: '',
        content: '',
        default: true,
        required: false,
        accountType: 'Single',
        content_word_count: 250,
        max_chapter_photos: 10,
        AIQuestions: []
      },
      {
        name: `Thank You`,
        text: `Thank You`,
        tips: '',
        content: '',
        default: true,
        required: false,
        accountType: 'Both',
        content_word_count: 250,
        max_chapter_photos: 10,
        AIQuestions: []
      }
    ],
    tipsModel: 'tips-model',
    currentEditChapter: null,
    isEditChapter: false,
    yesOrNo: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
    profileSettings: {
      max_chapters: 10,
      // content_word_count: 250,
      // max_chapter_photos: 10,
      tips_text: {
        new_chapters: '',
        covers_spread: ''
      },
      default_content: '',
      design_templates: [
        // { name: 'Classic', file: 'https://cdn.parentfinder.com/parent/5f0af437fc253d0be2015280/Flipbook/5f0dd4c4dc32fa1373abc9fe/16_1384.html' },
        // { name: 'Contemporary', file: 'https://cdn.parentfinder.com/parent/5ff77a5e7032fd448c419cdc/Flipbook/601492ece4dba16a41eef24f/21_1013.html' },
        // { name: 'Minimalist', file: 'https://cdn.parentfinder.com/parent/5ffd074fa41d4526a80e894a/Flipbook/6051ed747e74d9374909e190/21_1022.html' },
        // { name: 'Style 4', file: 'https://cdn.parentfinder.com/parent/5ff665c4775f5044c149fc0e/Flipbook/603cf2e0d6021a25405a03fd/21_1011.html' },
        // { name: 'Style 5', file: 'https://cdn.parentfinder.com/parent/5ff67e35775f5044c14a83bb/Flipbook/601dc4c3d6fe410dc73a7195/21_1012.html' },
        // { name: 'Style 6', file: 'https://cdn.parentfinder.com/parent/5fff93b1bc26d8324d2e1dd9/Flipbook/601c7b5ab8f6fe60c6b09cca/21_1026.html' }
      ],
      center_spread_required: true,
      back_cover_required: true,
      agency_approval_required: false,
      agency_approval_emails: [],
      default_chapters: [],
      ai: []
    },
    editorOption: {
      placeholder: 'Write your tips content here. Tips will help parents to complete their profile layout.'
    },
    config,
    content: '',
    init: {
      height: 400,
      placeholder: 'Write your tips content here. Tips will help parents to complete their profile layout.',
      paste_data_images: true,
      menubar: true,
      plugins: ['advlist autolink lists link charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount emoticons'],
      toolbar: 'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | insertfile template link anchor codesample | ltr rtl'
    },
    newDesign: {
      name: '',
      file: ''
    },
    rules: {
      flipbookLink: [
        v => !!v || 'Please enter the flipbook link',
        v => (v.indexOf('http') > -1 && v.indexOf('cdn.parentfinder.com/parent/') > -1 && v.indexOf('/Flipbook/') > -1 && v.indexOf('.html') > -1 && v.indexOf('_') > -1) || 'Please enter a valid flipbook link',
      ],
      name: [value => !!value || 'Design name is required.'],
      intRequired: [
        value => !!value || 'Please enter a value.',
        value => !isNaN(value) || 'Please enter a number.'
      ],
      emailRules: [
        v => !!v || 'Email address is required',
        v => {
          if (v && v.length) {
            let valid = true;
            v.forEach(email => {
              if (!isEmailValid(email)) {
                valid = false;
              }
            });
            return valid || 'Invalid email address';
          }
          return true;
        }
      ],
    },
    isAddDesign: false,
    addedNewChapter: false,
    addedNewCustomType: false,
    AISettings: [
      { name: 'model', type: 'string', value: 'text-davinci-003' },
      { name: 'temperature', type: 'number', value: 1 },
      { name: 'top_p', type: 'number', value: 1 },
      { name: 'frequency_penalty', type: 'number', value: 0 },
      { name: 'presence_penalty', type: 'number', value: 0 },
    ],
    isAISettingAdd: false,
    AIToneSettings: [
      { name: 'Tone', value: '' },
      { name: 'Intent', value: '' },
      { name: 'Audience', value: '' },
      { name: 'Style', value: '' },
      { name: 'Emotion', value: '' },
      { name: 'Domain', value: '' }
    ],
    AIToneOptions: {
      Tone: ['Formal', 'Informal', 'Optimistic', 'Worried', 'Friendly', 'Curious', 'Assertive', 'Encouraging', 'Surprised', 'Cooperative'],
      Intent: ['Inform', 'Describe', 'Convince', 'Tell A Story'],
      Audience: ['General', 'Knowledgeable', 'Expert'],
      Style: ['Formal', 'Informal'],
      Emotion: ['Mild', 'Strong'],
      Domain: ['General', 'Academic', 'Business', 'Technical', 'Creative', 'Casual']
    },
    currentChapter: null,
    selectedChapter: null,
    accountType: 'All',
    selectedType: null,
    currentType: null
  }),
  computed: {
    Agency: {
      get () {
        return store.state.Agency;
      },
      set (value) {
        store.commit('setAgency', value);
      }
    },
    displayChapters () {
      return this.profileSettings.default_chapters ? this.profileSettings.default_chapters.filter(x => ['new_chapters', 'covers_spread'].indexOf(x.name) === -1) : [];
    },
    filteredDefaultChapters () {
      return this.profileSettings.default_chapters && this.profileSettings.default_chapters.length ? this.profileSettings.default_chapters.filter(x => this.accountType === 'All' || !x.accountType || x.accountType === this.accountType || x.accountType === 'Both') : [];
    }
  },
  async created () {
    if (this.Agency.profile_doc_settings && Object.keys(this.Agency.profile_doc_settings).length) {
      this.profileSettings = this.Agency.profile_doc_settings;
    } else {
      await this.loadProfileSettings();
    }
    if (typeof this.profileSettings.tips_text === 'string') {
      this.profileSettings.tips_text = { new_chapters: '', covers_spread: '' };
    }
    if (!this.profileSettings.default_content) {
      this.profileSettings.default_content = '';
    }
    if (typeof this.profileSettings.back_cover_required === 'undefined') {
      this.profileSettings.back_cover_required = true;
    }
    if (typeof this.profileSettings.agency_approval_required === 'undefined') {
      this.profileSettings.agency_approval_required = false;
    }
    if (!this.profileSettings.agency_approval_emails) {
      this.profileSettings.agency_approval_emails = [];
    }
    if (typeof this.profileSettings.center_spread_required === 'undefined') {
      this.profileSettings.center_spread_required = true;
    }
    if (!this.profileSettings.default_chapters || !this.profileSettings.default_chapters.length) {
      this.profileSettings.default_chapters = this.defaultChapters;
    }
    if ((!this.profileSettings.ai || !this.profileSettings.ai.length) && (this.Agency.is_super_admin || session.getSession().adminUser)) {
      this.profileSettings.ai = this.AISettings;
    }
    this.profileSettings.default_chapters = this.profileSettings.default_chapters.map(x => {
      if (!x.AIQuestions) {
        x.AIQuestions = [];
      }
      if ((this.Agency.is_super_admin || session.getSession().adminUser) && !x.AISettings) {
        x.AISettings = this.AIToneSettings;
      }
      return x;
    });
    if (!this.profileSettings.custom_chapter_types) {
      this.profileSettings.custom_chapter_types = [];
    }
    this.profileSettings.custom_chapter_types = this.profileSettings.custom_chapter_types.map(x => {
      if (!x.AIQuestions) {
        x.AIQuestions = [];
      }
      if ((this.Agency.is_super_admin || session.getSession().adminUser) && !x.AISettings) {
        x.AISettings = this.AIToneSettings;
      }
      return x;
    });
    if (this.profileSettings.custom_chapter_types.length) {
      this.currentType = this.profileSettings.custom_chapter_types[0];
    }
    let defaults = [];
    if (this.profileSettings.default_chapters.findIndex(x => x.name === 'new_chapters') === -1) {
      defaults.push({ name: 'new_chapters', text: 'Default', hide: true });
    }
    // if (this.profileSettings.default_chapters.findIndex(x => x.name === 'covers_spread') === -1) {
    //   defaults.push({ name: 'covers_spread', text: 'Covers & Spread', hide: true });
    // }
    if (defaults.length) {
      this.profileSettings.default_chapters = [...defaults, ...this.profileSettings.default_chapters];
    }

    /* Set the first chapter as the current chapter */
    this.currentChapter = this.profileSettings.default_chapters.filter(x => ['covers_spread', 'new_chapters'].indexOf(x.name) === -1)[0];
    this.selectedChapter = this.currentChapter;
    /* Set the backup */
    this.profileSettingsBackup = this.profileSettings;
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async loadProfileSettings () {
      let { error, data } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'profile_doc_settings');
      if (error) {
        console.log(error);
      } else {
        if (data.length && data[0].profile_doc_settings && Object.keys(data[0].profile_doc_settings).length) {
          this.profileSettings = data[0].profile_doc_settings;
          if (!this.profileSettings.custom_chapter_types) {
            this.profileSettings.custom_chapter_types = [];
          }
        }
      }
    },
    getFlipbookFirstPage (flipbook) {
      let firstPage = null;
      if (flipbook) {
        firstPage = flipbook.substring(flipbook.lastIndexOf('/'), -1) + '/files/picon/1.jpeg';
      }
      return firstPage;
    },
    addNewDesign () {
      this.newDesign = {
        name: '',
        file: ''
      };
      this.isAddDesign = true;
    },
    closeDesignAdd () {
      this.isAddDesign = false;
      this.newDesign = {
        name: '',
        file: ''
      };
    },
    async submitNewDesign () {
      if (this.$refs.newDesignForm.validate()) {
        
        if (!this.profileSettings.design_templates) {
          this.profileSettings.design_templates = [];
        }
        this.profileSettings.design_templates.push(this.newDesign);
        await this.submitSettings(true);

      } else {
        this.isFormDataChanged = true;
      }
    },
    addNewQuestion () {
      let chapterIndex = this.profileSettings.default_chapters.findIndex(x => x.name === this.currentChapter.name);
      
      if (chapterIndex > -1 && this.currentChapter) {
        if (!this.currentChapter.AIQuestions) {
          this.currentChapter.AIQuestions = [];
        }
        this.currentChapter.AIQuestions.push({ question: '' });
        this.profileSettings.default_chapters[chapterIndex] = this.currentChapter;
        this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
      }
    },
    removeQuestion (questionIndex) {

      let chapterIndex = this.profileSettings.default_chapters.findIndex(x => x.name === this.currentChapter.name);

      if (chapterIndex > -1 && this.currentChapter) {
        if (this.currentChapter.AIQuestions[questionIndex]) {
          this.currentChapter.AIQuestions.splice(questionIndex, 1);
          this.isFormDataChanged = true;
          this.profileSettings.default_chapters[chapterIndex] = this.currentChapter;
          this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
        }
      }
    },
    addNewTypeQuestion () {
      let typeIndex = this.profileSettings.custom_chapter_types.findIndex(x => x.name === this.currentType.name);
      
      if (typeIndex > -1 && this.currentType) {
        if (!this.currentType.AIQuestions) {
          this.currentType.AIQuestions = [];
        }
        this.currentType.AIQuestions.push({ question: '' });
        this.profileSettings.custom_chapter_types[typeIndex] = this.currentType;
        this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
      }
    },
    removeTypeQuestion (questionIndex) {

      let typeIndex = this.profileSettings.custom_chapter_types.findIndex(x => x.name === this.currentType.name);

      if (typeIndex > -1 && this.currentType) {
        if (this.currentType.AIQuestions[questionIndex]) {
          this.currentType.AIQuestions.splice(questionIndex, 1);
          this.isFormDataChanged = true;
          this.profileSettings.custom_chapter_types[typeIndex] = this.currentType;
          this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
        }
      }
    },
    async submitSettings (isDesignChange = false) {
      if (isDesignChange || this.$refs.profileLayoutSettings.validate()) {
        /* if (!isDesignChange && !this.profileSettings.tips_text.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
          swal.fire({
            type: 'warning',
            title: 'Tips are required.',
            text: 'Please add the the tips text',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            onClose: () => {
              this.isFormDataChanged = true;
            }
          });
        } else { */
        this.isFormDataChanged = false;

        let updatePayload = JSON.parse(JSON.stringify(this.Agency));
        // Filter out only valid emails from this.profileSettings.agency_approval_emails
        if (this.profileSettings.agency_approval_required && this.profileSettings.agency_approval_emails && this.profileSettings.agency_approval_emails.length) {
          this.profileSettings.agency_approval_emails = this.profileSettings.agency_approval_emails.filter(x => isEmailValid(x));
        }
        updatePayload.profile_doc_settings = this.profileSettings;
        updatePayload.updated_from = 'basic';
        
        let { error, data, status } = await update('Agency', updatePayload, updatePayload.id);
        if (error) {
          console.log('error', error);
          this.isFormDataChanged = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to update the data'
          };
        } else {
          this.newDesign = {
            name: '',
            file: ''
          };
          this.Agency.profile_doc_settings = this.profileSettings;
          this.profileSettingsBackup = this.profileSettings;
          this.closeDesignAdd();
          swal.fire({
            type: 'success',
            title: 'Updated',
            text: 'The profile layout settings were updated',
            showConfirmButton: false,
            timer: 2500
          });
        }
        // }
      } else {
        this.isFormDataChanged = true;
      }
    },
    deleteTemplate (index) {
      if (index === -1) {
        return;
      }
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          if (this.profileSettings.design_templates && this.profileSettings.design_templates[index]) {
            this.profileSettings.design_templates.splice(index, 1);
            await this.submitSettings(true);
          }
        }
      });
    },
    cancelEdit () {
      this.profileSettings = this.profileSettingsBackup;
      this.isFormDataChanged = false;
    },
    editChapterName (chapter) {
      this.currentEditChapter = chapter;
      this.isEditChapter = true;
      this.isFormDataChanged = true;
    },
    deleteChapter (chapter, index) {
      if (index < 0) {
        return;
      }
      swal.fire({
        title: 'Confirm',
        text: 'Are you sure to delete the chapter ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          if (this.profileSettings.default_chapters && this.profileSettings.default_chapters[index]) {
            this.profileSettings.default_chapters.splice(index, 1);
            this.isFormDataChanged = true;
          }
        }
      });
    },
    sortChapters () {
      this.isFormDataChanged = true;
      this.profileSettings = this.profileSettings;
    },
    addNewChapter () {
      if (this.profileSettings.default_chapters && this.profileSettings.default_chapters.length < this.profileSettings.max_chapters) {
        this.profileSettings.default_chapters.push({
          name: 'New Chapter',
          text: 'New Chapter',
          tips: '',
          content: '',
          default: false,
          required: false,
          AIQuestions: [],
          content_word_count: 250,
          max_chapter_photos: 10,
          accountType: 'Both'
        });
        this.isFormDataChanged = true;
        this.addedNewChapter = true;
        setInterval(() => {
          this.addedNewChapter = false;
        }, 3000);
        // this.editChapterName(this.profileSettings.default_chapters[this.profileSettings.default_chapters.length - 1]);
      }
    },
    addNewCustomType () {
      if (!this.profileSettings.custom_chapter_types) {
        this.profileSettings.custom_chapter_types = [];
      }
      this.profileSettings.custom_chapter_types.push({
        name: '',
        text: 'New Custom Type',
        tips: '',
        content: '',
        AIQuestions: [],
        AISettings: this.AIToneSettings,
        content_word_count: 250,
        max_chapter_photos: 10,
        accountType: 'Both'
      });
      this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
      this.isFormDataChanged = true;
      this.addedNewCustomType = true;
      setInterval(() => {
        this.addedNewCustomType = false;
      }, 3000);
    },
    deleteCustomType (type, index) {
      if (index < 0) {
        return;
      }
      const self = this;
      swal.fire({
        title: 'Confirm',
        text: 'Are you sure to delete the custom chapter type?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          if (this.profileSettings.custom_chapter_types && this.profileSettings.custom_chapter_types[index]) {
            this.profileSettings.custom_chapter_types.splice(index, 1);
            this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
            this.isFormDataChanged = true;
          }
        }
      });
    },
    changeCurrentChapter () {
      this.currentChapter = this.selectedChapter;
    },
    changeChapterName (chapter, index) {
      if (this.profileSettings.default_chapters[index]) {
        this.profileSettings.default_chapters[index].name = chapter.name;
        this.profileSettings.default_chapters[index].text = chapter.name;
        this.cancelChapterEdit();
        this.isFormDataChanged = true;
      }
    },
    cancelChapterEdit () {
      this.currentcurrentEditChapter = null;
      this.isEditChapter = false;
    },
    async addAISetting () {
      
      this.profileSettings.ai.push({
        name: '',
        type: '',
        value: ''
      });
      this.isAISettingAdd = true;
      this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
    },
    removeAISetting (configIndex) {
      swal.fire({
        title: 'Are you sure?',
        text: 'Do you want remove this setting?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            this.profileSettings.ai.splice(configIndex, 1);
            await this.submitSettings();
            this.profileSettings = JSON.parse(JSON.stringify(this.profileSettings));
          })();
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ProfileDocuments/setup.vue